import { Component } from "../interface/component";
import EventsHandler from "../service/events";
import EVENTS from "../constants/events";

export class MobileMenu implements Component {
    private $root: JQuery;
    private $offcanvas: JQuery;
    private $submenu_toggles: JQuery;
    private events:EventsHandler;

    constructor(root: HTMLElement) {
        this.$root = $(root);
        this.$offcanvas = $('.l-offcanvas-nav');
        this.$submenu_toggles = this.$offcanvas.find('.js-accordion-nav-toggle');
    }

    init() {
        this.setupMenuGui();
        this.$root.on('click', this.toggleMenu);
        this.$submenu_toggles.on('click', this.toggleSubMenu);

        // Set the initial state of .c-sub-nav to hidden
        $('.c-sub-nav').hide();
    }

    setupMenuGui = () => {
        // Adding decoration spans via JS to keep html clutter-free for screen readers etc.
        // let element = $('<span role="presentation"></span>');
        //
        // for(let i = 0; i < 4; i++) {
        //     element.clone().appendTo(this.$root);
        // }
    }

    toggleMenu = () => {
        if (this.$root.hasClass('c-nav-toggle--active')){
            this.events.emit(EVENTS.NAVIGATION_HIDE);
        }else{
            this.events.emit(EVENTS.NAVIGATION_SHOW);
        }
        this.$root.toggleClass('c-nav-toggle--active');
        this.$offcanvas.toggleClass('l-offcanvas-nav--active');
        $('body').toggleClass('hide-scroll nav--active');
    }

    toggleSubMenu = (ev: Event) => {
        let element = $(ev.currentTarget);
        ev.preventDefault();
        element.toggleClass('c-accordion-nav-toggle--active');

        // Use slideToggle for a sliding effect
        element.next('.c-sub-nav').slideToggle(250).toggleClass('c-sub-nav--open');
    }

    public setEventHandler(events:EventsHandler) {
        this.events = events;
    }
}
